import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import QuizContainer from "../../components/Quiz/QuizContainer";
import WorkplaceResults from "./WorkplaceResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import { QuizResult } from "../../shared/types";
import { workplaceQuestions } from "./questions";
import { webhookService } from "../../shared/webhookService";

const WorkplaceQuiz: React.FC = () => {
  const [results, setResults] = useState<QuizResult[]>([]);
  const [showQuiz, setShowQuiz] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const navigate = useNavigate();

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    setShowQuiz(true);
  };

  const handleQuizComplete = async (quizResults: QuizResult[]) => {
    setResults(quizResults);

    // Prepare webhook data
    const webhookData = {
      quizName: "Workplace Quiz",
      userInfo: userInfo || {},
      responses: quizResults.map((result, index) => ({
        questionNumber: index + 1,
        question: result.question,
        answer: result.answer,
      })),
      timestamp: new Date().toISOString(),
    };

    console.log("Workplace Quiz - Sending webhook data:", webhookData);

    // Send to webhook (with automatic retry on failure)
    await webhookService.submitQuizData(webhookData);

    // Use relative navigation
    navigate("results", { replace: true });
  };

  const handleRestart = () => {
    setResults([]);
    setShowQuiz(false);
    setUserInfo(null);
    // Use relative navigation
    navigate(".", { replace: true });
  };

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            showQuiz ? (
              <QuizContainer
                questions={workplaceQuestions}
                onQuizComplete={handleQuizComplete}
              />
            ) : (
              <UserInfoForm onSubmit={handleUserInfoSubmit} />
            )
          }
        />
        <Route
          path="results"
          element={
            <WorkplaceResults results={results} onRestart={handleRestart} />
          }
        />
      </Routes>
    </div>
  );
};

export default WorkplaceQuiz;
